import { Modal, Button } from "@mui/material"
import MDBox from "../MDBox"
import MDTypography from "../MDTypography"
import SuccessIcon from "components/icons/SuccessIcon"
import FailedIcon from "components/icons/FailedIcon"

const ModalLeaveSubmitStatus = (props) => {
  const { isOpen, onClose, data, status, errorMessage } = props
  const leaveHistory = [
    { id: 1, type: "Contractual leaves", day: 20 },
    { id: 2, type: "Entitled leaves till this month", day: 2 },
    { id: 3, type: "Old leaves", day: 9 },
    { id: 4, type: "Total leaves taken till this month", day: 4 },
    { id: 5, type: "Old leaves taken", day: 4 },
    { id: 6, type: "Total entitled leaves", day: 4 },
  ]

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="modal-leave-submit-status-container">
        <div className="modal-leave-submit-status-container-wrapper">
          <MDBox className="modal-leave-submit-status-header">
            <MDTypography
              className="modal-leave-submit-status-title"
              variant="h5"
            >
              Leave Application
            </MDTypography>
          </MDBox>

          <MDBox className="modal-leave-submit-status-content">
            <div className="icon">
              {!errorMessage ? <SuccessIcon /> : <FailedIcon />}
            </div>
            <MDBox className="modal-leave-alert-form">
              {errorMessage
                ? errorMessage
                : `Your leave request has been submitted ${
                    status ? "successfully" : "unsuccessfully"
                  }`}
            </MDBox>
          </MDBox>
          <MDBox className="modal-leave-submit-status-footer">
            {status ? (
              <>
                <Button
                  className="cancel-button"
                  variant="contained"
                  fullWidth
                  color="primary"
                  onClick={onClose}
                >
                  OK
                </Button>
                <Button
                  className="cancel-button"
                  variant="contained"
                  fullWidth
                  color="primary"
                  onClick={onClose}
                >
                  Leave Application
                </Button>
              </>
            ) : (
              <Button
                className="cancel-button"
                variant="contained"
                fullWidth
                color="primary"
                onClick={onClose}
              >
                Close
              </Button>
            )}
          </MDBox>
        </div>
      </div>
    </Modal>
  )
}

export default ModalLeaveSubmitStatus
